var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirCompressor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AIR_COMPRESSOR_ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #AIR_COMPRESSOR_ICON .cls-1 {\n        fill: #7826ff;\n      }\n\n      #AIR_COMPRESSOR_ICON .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_405",
    "data-name": "Pfad 405",
    className: "cls-1",
    d: "M36 18A18 18 0 1 1 18 0a18 18 0 0 1 18 18"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1033",
    "data-name": "Gruppe 1033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_406",
    "data-name": "Pfad 406",
    className: "cls-2",
    d: "M25 11.113a7 7 0 1 0-7 7 7.007 7.007 0 0 0 7-7m-1.053 0A5.947 5.947 0 1 1 18 5.167a5.953 5.953 0 0 1 5.946 5.946M21.954 8.3l-2.8 2.8c0 .042.012.082.012.125A1.226 1.226 0 1 1 17.943 10a1.2 1.2 0 0 1 .313.046l2.726-2.726c.006-.007.015-.008.021-.014a4.872 4.872 0 1 0 .951 1M19.649 21.5v-1.873h-3.3V21.5h-3.188V23h9.678v-1.5zm7.883 3H8.467v4h19.065zm-4.693 5.4H13.16v1.5h9.679z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCompressor);
export default __webpack_public_path__ + "static/media/air-compressor.13ef3afec286b44aab4acd2754cf4732.svg";
export { ForwardRef as ReactComponent };